module.exports = __webpack_public_path__ + "img/partner_3.1ef79569.jpg";